import { useEffect } from "react";

export function useFavicon() {
  useEffect(() => {
    const lightFavicon = "/insi-fav-blue.png";
    const darkFavicon = "/insi-fav-white.png";

    const updateFavicon = (e) => {
      const isDark = e ? e.matches : window.matchMedia("(prefers-color-scheme: dark)").matches;
      const favicon = document.querySelector<HTMLLinkElement>("link[rel='icon']");

      if (favicon) {
        favicon.href = isDark ? darkFavicon : lightFavicon;
      } else {
        const link = document.createElement("link");
        link.rel = "icon";
        link.href = isDark ? darkFavicon : lightFavicon;
        document.head.appendChild(link);
      }
    };

    // Initial load
    updateFavicon();

    // Listen for changes in theme
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    mediaQuery.addEventListener("change", updateFavicon);

    return () => mediaQuery.removeEventListener("change", updateFavicon);
  }, []);
}
